<div class="custom-chip" [class.removable]="removable">
    <span class="chip-label">{{ label }}</span>
    <button *ngIf="removable" class="chip-remove-button" (click)="onRemoveClick()">
      <i class="pi pi-times" style="color: #2B7DF8"></i>
    </button>
  </div>